import fileDownload from "js-file-download";
import { useState } from "react";
import { apiLetter } from "../../../../api/apiLetter1Guarantor";
import { LoadingAbsolute } from "../../../../ui";
import { errorModal, questionModal, successModal } from "../../../../utils";
import { diasFecActualFecPromesa, fechaMembrete, NumeroALetras, paymentAmount, separator, sumar } from "../CalcFunctionPay";
import './Letters.css';

export const Letter1Asociated = ({ NumeroPrestamo, NombreAsociado, DireccionCasa, Municipio, CIF, CuotaCapital, CuotasVencidas, SaldoInteres, MontoMora, DiasMora, nombre, valuesForm, SaldoActual, CapitalVencido, Tasa, cif }) => {

    const [loader, setLoader] = useState(false);

    const generateLetter1Associated = async () => {
        setLoader(true);
        if (!valuesForm) {
            setLoader(false);
            errorModal('Debe llenar el formulario');
        } else {
            let data1 = { template: { name: "carta1-asociado-main" }, data: { 'DetalleEspecifico': { fecha: valuesForm, NombreAsociado, DireccionCasa, Municipio, NumeroPrestamo, CIF, monto: paymentAmount(SaldoActual, Tasa, valuesForm, CapitalVencido, CuotaCapital, CuotasVencidas, SaldoInteres, MontoMora), diasTotales: DiasMora + diasFecActualFecPromesa(valuesForm), nombre, cif } } };

            apiLetter.post('', data1).then((response) => {
                setLoader(false);
                successModal('Reporte generado correctamente', 'center');
                const date = `${new Date().getDate()}-${(new Date().getMonth() + 1)}-${new Date().getFullYear()} ${new Date().getHours()}h${new Date().getMinutes()}min`;
                fileDownload(response.data, `Carta 1 asociado ${date}.pdf`);
            }).catch((error) => {
                errorModal('No se ha podido generar el reporte, por favor intente nuevamente.')
            });
        }
    }

    return (
        <div className="sm:mt-0 md:mt-8">
            {loader && <LoadingAbsolute />}
            <div className="md:bg-white md:rounded-lg md:shadow-md md:m-4">
                <div className="md:w-full md:border-t-8 md:border-blue-900 md:rounded-lg md:flex hidden">

                    <div className="invoice-box">
                        <table>
                            <tr className="table-border">
                                <td className="table-border">
                                    <div className="flex items-center">
                                        <div className='company-logo'></div>
                                    </div>
                                </td>
                                <td className="table-border">
                                    <div className="ml-1 my-2">
                                        Nombre:
                                    </div>
                                    <div className="text-2xl text-center mb-2">
                                        <b>NOTIFICACIÓN DE COBRO AL ASOCIADO</b>
                                    </div>
                                </td>
                                <td className="table-border">
                                    <div className="line">
                                        <div className="ml-1 mr-16 my-1">
                                            REGISTRO:
                                        </div>
                                        <div className="text-xl text-center">
                                            <b>R2-PCAD-1</b>
                                        </div>
                                    </div>
                                    <div>
                                        <div className="ml-1 mr-16 my-1">
                                            VERSIÓN:
                                        </div>
                                        <div className="text-xl text-center">
                                            <b>1</b>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </table>

                        <div className="mx-12 mt-8">
                            <p className="w-full text-right">{fechaMembrete(valuesForm)}</p>


                            <p className="text-[12pt]">
                                Señor(a)
                                <br /> {NombreAsociado}
                                <br /> {DireccionCasa}
                                <br /> {Municipio}
                                <br /> Crédito No. {NumeroPrestamo} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; CIF: {CIF}
                            </p>
                            <p className="text-justify mt-10">
                                Cordial Saludo Señor(a) <b>{NombreAsociado}</b>, el motivo
                                de la presente es para recordarle que según su último estado de cuenta,
                                usted presenta un saldo vencido de <b>Q.
                                    {
                                        valuesForm
                                            ? separator(paymentAmount(SaldoActual, Tasa, valuesForm, CapitalVencido, CuotaCapital, CuotasVencidas, SaldoInteres, MontoMora))
                                            : separator((sumar(CuotaCapital, CuotasVencidas, SaldoInteres, MontoMora)).toFixed(2))
                                    } ({
                                        valuesForm
                                            ? NumeroALetras(paymentAmount(SaldoActual, Tasa, valuesForm, CapitalVencido, CuotaCapital, CuotasVencidas, SaldoInteres, MontoMora))
                                            : NumeroALetras((sumar(CuotaCapital, CuotasVencidas, SaldoInteres, MontoMora)).toFixed(2))
                                    })
                                </b> el cual aún no ha sido pagado.
                            </p>
                            <p className="text-justify mt-4">
                                Hace ya <b>{valuesForm ? DiasMora + diasFecActualFecPromesa(valuesForm) : DiasMora}</b> días que usted adeuda esta cantidad, según contrato y pagaré
                                firmado en común acuerdo ante nuestra entidad, los pagos son puntuales en las
                                fechas establecidas según su plan de pagos.
                            </p>
                            <p className="text-justify mt-4">
                                Por lo tanto, esta notificación es para reanudar la confianza brindada y hacer
                                saber que solamente tiene un plazo de tres días hábiles para cumplir con el
                                requerimiento y no perjudicar con gasto adicionales de cobranza.
                            </p>
                            <p className="text-justify mt-4">
                                Sin otro particular, y a la espera de su pronta respuesta,
                            </p>
                            <p className="text-center mt-12">
                                Atentamente,<br />
                                {nombre}<br />
                                Departamento de Cobro Administrativo<br />
                                Cel: {cif}
                            </p>
                            <p className="text-justify mt-8">
                                Fecha de compromiso de pago: ________________________ f.____________________<br />
                                Nombre de quien recibe la notificación: _____________________ Tel: _______________<br />
                                Observaciones: ___________________________________________________________<br />
                                ________________________________________________________________________<br />
                                ________________________________________________________________________<br />
                            </p >
                        </div >
                    </div >
                </div >
                <div className="p-4 flex">
                    <button
                        onClick={() => questionModal('¿Desea generar la carta?', generateLetter1Associated, 'Generar carta')}
                        className="w-full px-8 py-3 text-center text-white bg-blue-900 rounded-lg hover:bg-blue-800 hover:text-white font-bold text-sm"
                    >Generar carta
                    </button>
                </div>
            </div >
        </div >
    )
}
